namespace GeniuzPOS.Inventory {
    export interface IcStockTransferRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        ConcatRefDocNo2?: string;
        WhsIdFm?: string;
        ConcatWhsIdFm?: string;
        WhsIdTo?: string;
        Remark?: string;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        TransferDtList?: IcStockTransferDtRow[];
        CancelFg?: CancelFgstatus;
    }

    export namespace IcStockTransferRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockTransfer';
        export const lookupKey = 'Inventory.IcStockTransfer';

        export function getLookup(): Q.Lookup<IcStockTransferRow> {
            return Q.getLookup<IcStockTransferRow>('Inventory.IcStockTransfer');
        }
        export const deletePermission = '2Inventory:รายการ:โอนระหว่างคลัง:Modify';
        export const insertPermission = '2Inventory:รายการ:โอนระหว่างคลัง:Modify';
        export const readPermission = '2Inventory:รายการ:โอนระหว่างคลัง:View';
        export const updatePermission = '2Inventory:รายการ:โอนระหว่างคลัง:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            ConcatRefDocNo2 = "ConcatRefDocNo2",
            WhsIdFm = "WhsIdFm",
            ConcatWhsIdFm = "ConcatWhsIdFm",
            WhsIdTo = "WhsIdTo",
            Remark = "Remark",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            TransferDtList = "TransferDtList",
            CancelFg = "CancelFg"
        }
    }
}
